module.exports = __webpack_public_path__ + "img/giroflee_ravenelle.e0406147.jpg";